import React, { useEffect } from 'react';
import Draggable from 'react-draggable';
import { useChatbot } from 'Contexts/ChatbotContext';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import '../../pages/ChatBotIA/Chatbot.css';
import Panel from 'Components/Panel/Panel';
import ChatbotIcon from "../../Components/SideBar/assets/icons/Chatbot.png";
import xSymbol from "../../Components/SideBar/assets/icons/x-symbol.png";

const ChatbotModal = () => {
  const {
    messages,
    setMessages,
    userInput,
    setUserInput,
    messagesEndRef,
    setIsModalOpen
  } = useChatbot();

  const screenSize = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  useEffect(() => {
    if (messagesEndRef?.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const handleSendMessage = async () => {
    if (!userInput.trim()) return;

    const formatted = userInput.charAt(0).toUpperCase() + userInput.slice(1);
    setUserInput('');
    setMessages(prev => [...prev, { role: 'user', content: formatted }]);

    try {
      const text = await ExecuteAxios.api('post', `/chat/send/`, { userMessage: formatted }, false);
      setMessages(prev => [...prev, { role: 'Redech', content: text }]);
    } catch (error) {
      console.error('Erro ao enviar a mensagem:', error);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSendMessage();
  };

  const getBounds = () => ({
    right: 200,
    bottom: screenSize.height - 250
  });

  return (
    <Draggable defaultPosition={{ x: 0, y: 230 }} bounds={getBounds()}>
      <div className="chatbot-modal">
        <Panel style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="chatbot-header" style={{ display: 'flex', flexDirection: 'row-reverse', margin: '4px' }}>
            <img
              src={xSymbol}
              onClick={() => setIsModalOpen(false)}
              style={{ width: '15px', cursor: 'pointer', backgroundColor: 'transparent' }}
              className="close-button"
              alt="Fechar"
            />
          </div>
          <div className="chatbot-messages">
            {messages.map((msg, i) => (
              <div key={i} className={`message ${msg.role === 'user' ? 'user-message' : 'bot-message'}`}>
                {msg.role === 'Redech' && <img src={ChatbotIcon} alt="Bot" className="bot-icon" />}
                {msg.content}
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
          <div className="chatbot-input">
            <input
              type="text"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Digite sua pergunta..."
            />
            <button onClick={handleSendMessage}>Enviar</button>
          </div>
        </Panel>
      </div>
    </Draggable>
  );
};

export default ChatbotModal;
